import React, { useState, useEffect, useRef, forwardRef, useImperativeHandle } from 'react';
import { Col, Row } from 'react-bootstrap';
import { OnlineHighcharts } from './OnlineHighcharts'
import { useTranslation } from 'react-i18next';
import DropdownChartSpeedBreathing from './DropdownChartSpeedBreathing';

const BreathingHighchartsForwardRef = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const chartComponentRef = useRef(null);  

  useImperativeHandle(ref, () => ({
    setInitialData(data, seriesSettings) {
      chartComponentRef.current.setInitialData(data, seriesSettings);
    },
    setDataViewMode(mode) {
      chartComponentRef.current.setDataViewMode(mode);
    },
    addNewDataToChart(data, seriesId) {
      chartComponentRef.current.addNewDataToChart(data, seriesId);
    },
    setupYAxis(settings) {
      chartComponentRef.current.setupYAxis(settings);    
    },
    scrollToEnd() {
      chartComponentRef.current.scrollToEnd();
    }
  }));

  useEffect(() => {    

  }, []);

  const otherChartOptions = {
    chart: {     
    },
    xAxis: {
      maxRange: undefined
    },    
    plotOptions: {
      series: {
        //getExtremesFromAll: true,
        point: {
          events: {
            //mouseOver: function () { setHoverData(this.category); }
          }
        },
        dataGrouping: {
          enabled: true,
          anchor: 'middle',          
        }        
      },
      line: {
        dataGrouping: {
          dateTimeLabelFormats: {
            millisecond:  ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
            second:       ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
            minute:       ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
            hour:         ['%H:%M %S.%Ls', '%H:%M %S.%Ls', '-%H:%M %S.%Ls'],
          }
        }
      }
    }

  };


  return (
    <>
      <Row>
        <Col sm={10}>
          <DropdownChartSpeedBreathing onSelectionChangedCallback={(value) => chartComponentRef.current.setChartExtremesX(value)} /><span className="px-3"></span>          
        </Col>
        <Col>
        </Col>
      </Row>
      <Row>
        <Col className="px-0">
          <OnlineHighcharts ref={chartComponentRef} specificChartOptions={otherChartOptions} seriesName={props.seriesName} defaultCellTimeXms={400} />
        </Col>
      </Row>
    </>
  )


});

BreathingHighchartsForwardRef.displayName = 'BreathingHighchartsForwardRef';

export const BreathingHighcharts = React.memo(BreathingHighchartsForwardRef);